import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { v1IncidentKeys } from './v1Incident.queryKeys';
import { UpdateV1IncidentBody, V1Incident } from './v1Incident.types';
import { applyExerciseIncidentName } from 'utils/incidentExerciseName';
import { keys as incidentKeys } from 'components/IAP/hooks/incidentHooks';

export function useUpdateV1IncidentMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    V1Incident,
    undefined,
    { v1IncidentId: UUID } & UpdateV1IncidentBody
  >({
    mutationFn: async ({ v1IncidentId, ...patch }) => {
      const name = applyExerciseIncidentName(patch.name, patch.incidentTypes);
      const resp = await axios.patch<V1Incident>(
        `${config.apiGateway.v1Incidents}/${v1IncidentId}`,
        {
          ...patch,
          name,
        }
      );

      return resp.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: v1IncidentKeys.get(data.id) });
      queryClient.invalidateQueries({ queryKey: incidentKeys.get(data.id) });
      toast.success('Incident updated.');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
  });
}
